import { computed } from 'vue';
import { useStore } from 'vuex';

/**
 *
 * @returns {{
 * currentPage: import('vue').Ref<number>,
 * firstAltDot: import('vue').Ref<number>,
 * currentPageOnHover: import('vue').Ref<number | null>
 * updateCurrentPage: (index: number) => void,
 * updateCurrentPageOnHover: (index: number) => void,
 * updateCarousel: (index: number) => void,
 * updateFirstAltDot: (value: number) => void,
 * }}
 */

export function useCarouselSelectedImage() {
  const store = useStore();

  const currentPage = computed({
    get() {
      return store.state.extraStore.carouselSelectedImage.currentPage;
    },
    set(value) {
      store.commit('extraStore/set', { scope: 'carouselSelectedImage', key: 'currentPage', value });
    },
  });

  const firstAltDot = computed({
    get() {
      return store.state.extraStore.carouselSelectedImage.firstAltDot;
    },
    set(value) {
      store.commit('extraStore/set', { scope: 'carouselSelectedImage', key: 'firstAltDot', value });
    },
  });

  const currentPageOnHover = computed({
    get() {
      return store.state.extraStore.carouselSelectedImage.currentPageOnHover;
    },
    set(value) {
      store.commit('extraStore/set', { scope: 'carouselSelectedImage', key: 'currentPageOnHover', value });
    },
  });

  /** @param {number} value */
  const updateFirstAltDot = (value) => {
    firstAltDot.value = value;
  };

  /** @param {number} index */
  const updateCurrentPage = (index) => {
    currentPage.value = index;
  };

  /** @param {number} index */
  const updateCurrentPageOnHover = (index) => {
    currentPageOnHover.value = index;
  };

  /** @param {number} index */
  const updateCarousel = (index) => {
    currentPageOnHover.value = null;
    currentPage.value = index;
  };

  return {
    currentPage,
    currentPageOnHover,
    firstAltDot,
    updateCurrentPage,
    updateCurrentPageOnHover,
    updateCarousel,
    updateFirstAltDot,
  };
}

export default useCarouselSelectedImage;
